import { useCallback, FC } from 'react'
import { Page } from 'src/app/types'
import { useAppDispatch } from 'src/hooks'
import { setCurrentPage } from 'src/app/page'
import Caret from 'src/Icon/Caret'

type BackButtonProps = { styles?: string; page: Page }

const BackButton: FC<BackButtonProps> = ({ page, styles }) => {
  const dispatch = useAppDispatch()

  const onClick = useCallback(() => {
    dispatch(setCurrentPage({ page }))
  }, [page, dispatch])

  return (
    <button className={`inline-flex items-center ${styles}`} onClick={onClick}>
      <Caret className="rotate-90" />
      Back
    </button>
  )
}

export default BackButton
